<template>
  <div class="user-info box">
    <form-element
        v-if="viewForm"
        :el-conf="baseFormConf"
        :show-cancel-btn="true"
        confirmBtnLabel="确定"
        @onCancel="onCancel"
        @onSubmit="saveUserInfo"></form-element>
  </div>
</template>

<script>
import userApi from "@/assets/js/userApi";
import zyDialog from "../../components/element/dialog";
export default {
  name: "user-info",
  components  : { zyDialog },
  data(){
    return {
      viewForm            : false,
      showAvatarDialog    : false,
      showRealnameDialog  : false,
      showBaseInfoDialog  : false,
      baseFormConf        : false,
      nameFormConf        : false,
      avatarFormConf      : false,
      viewUserChangeBtn   : false,
    }
  },
  methods : {
    getUserinfoConfig(){
      this.viewForm = false;
      userApi.getCurUsrInfo().then( _info => {
        let _conf         = {
          "realname": {"column": "realname", "index": 0, "label": "真实姓名", "required": true, "type": "string"},
          "telphone": {
            "column": "telphone",
            "index": 0,
            "label": "手机号码",
            "pattern": "^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\\d{8}$",
            "required": true,
            "type": "string"
          },
          "company": {
            "column": "company",
            "index": 0,
            "label": "企业名称",
            "required": false,
            "type": "string"
          },
          "email": {"column": "email", "index": 0, "label": "电子邮箱", "required": false, "type": "email"},
          "department": {"column": "department", "index": 0, "label": "所在部门", "required": false, "type": "string"},
          "userPosition": {"column": "userPosition", "index": 0, "label": "职务", "required": false, "type": "string"},
          "avatar": {
            "column": "avatar",
            "index": 0,
            "label": "用户头像",
            "required": false,
            "type": "image",
            "fileSize": 65536
          },
          "birthday": {"column": "birthday", "index": 0, "label": "出生日期", "required": false, "type": "string"},
          "others": {"column": "others", "index": 0, "label": "备注", "required": false, "type": "mulitstr"}
        };
        let _formConf     = [];
        this.baseFormConf = {};
        Object.keys( _conf ).forEach( _k => {
          let _d    = _conf[_k];
          _d.key    = _d.column;
          _d.value  = _info[_d.key] || "";
          _formConf.push( _d );
        } )
        _formConf.sort( ( _a, _b ) => {
          return _a.index - _b.index;
        } )
        _formConf.forEach( _f => {
          if( _f.column == 'avatar' ){
          }
          else {
            this.baseFormConf[_f.column] = _f
          }
        } );
        this.viewForm = true;
      } )
    },
    saveUserInfo( data ){
      userApi.saveUserInfo( data, _r => {
        this.$emit( 'saveSuccess' );
      } )
    },
    onCancel( data ){
      this.$emit( 'saveCancel' );
    },
    logout(){
      userApi.doLogout( _r => {
        sessionStorage.clear();
        localStorage.clear();
        this.$store.dispatch( "setLogin", false );
      } );
    },
    changeUser( command ){
      //根据ID获取用户TOKEN
      //记录用户TOKEN

      console.log( 1111, command );
    }
  },
  created() {
    this.getUserinfoConfig();
  }
}
</script>

<style lang="less" scoped>
@import "~@/assets/define.less";
.data-table{
  .table-row{
    .row-item{
      margin-bottom:0px;
      width:auto;
      &:first-child{
        width:120px
      }
      &:last-child{
        width:calc( 100% - 120px );
      }
      &:nth-child( 2 ){
        &.unFinished:after{
          content : "待完善";
          color:#color[secondary];
        }
      }
    }
    &:last-child{
      .row-item{
        margin-bottom:#blank[normal];
      }
    }
  }
  &.info-title{
    .row-item{
      margin-top:0px;
      margin-bottom:0px !important;
    }
  }
}
.link-logout{
  text-align:right;
}
.user-info-preview{
  max-width:1000px;
  margin-left:auto;
  margin-right:auto;
  height:580px;
}
.user-info{
  .user-avatar{
    width:120px;
    img{
      border-radius: 50%;
    }
  }
  .user-name{
    .row-item:first-child{
      padding-left:25px;
      //text-align: center;
    }
  }
}

.change-user{
  position: relative;
  top:2px;
  margin-right:10px;
}
</style>
